import api from './api';

const genAIAdminToken = process.env.REACT_APP_GENAI_ADMIN_SECURITY_TOKEN;

const CategoryManagementApi = {
  getCategories: (params = {}) =>
    api.get('/genai-admin/categories', {
      params,
      headers: { 'secure-token': genAIAdminToken },
    }),

  createCategory: (data) =>
    api.post('/genai-admin/categories', data, {
      headers: { 'secure-token': genAIAdminToken },
    }),

  updateCategory: (id, data) =>
    api.put(`/genai-admin/categories/${id}`, data, {
      headers: { 'secure-token': genAIAdminToken },
    }),

  updateCategoryStatus: (id, data) =>
    api.patch(`/genai-admin/categories/${id}/status`, data, {
      headers: { 'secure-token': genAIAdminToken },
    }),

  deleteCategory: (id) =>
    api.delete(`/genai-admin/categories/${id}`, {
      headers: { 'secure-token': genAIAdminToken },
    }),
};

export default CategoryManagementApi;
